const styles = theme => ({
  container: {
    width: '100%',
  },
  label: {
    color: theme.palette.primary.foreground,
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '21px',
    margin: '0 0 8px 0',
  },
  field: {
    '& > .MuiInputBase-formControl': {
      border: `1px solid ${theme.palette.primary.borderColor}`,
      borderRadius: '0px',
      '&.Mui-focused fieldset': {
        border: '0 !important',
        boxShadow: 'none !important',
      },
      '& > fieldset': {
        border: '0 !important',
        boxShadow: 'none !important',
      },
    },

    '& .MuiOutlinedInput-root': {
      '& .MuiOutlinedInput-input': {
        height: 'auto',
        padding: '10px 10px 10px 10px !important',
        borderRadius: '0px',
        color: theme.palette.primary.adgmBlack,
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: '18px',
        '&::placeholder': {
          color: theme.palette.secondary.disableLightGray,
          opacity: '1',
        },
      },
    },
  },
  input: {
    color: theme.palette.primary.adgmBlack,
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '18px',
    '&::placeholder': {
      color: theme.palette.secondary.disableLightGray,
      textTransform: 'lowercase',
    },
  },
});

export default styles;
